import {SET_TOKEN,SET_USER_INFO} from '../common/constant'
export const setToken=token=>({type: SET_TOKEN, data: token})
export const setUserInfo=menuData=>({type: SET_USER_INFO, data: menuData})